import API from "./lib/api";
import { c2cVoucherUrl } from "./lib/url";


export const getAllC2CVoucherApi = async (restaurant_id, query) => {
    try {
        const { data } = await API.get( 
            `restaurant/${restaurant_id}${c2cVoucherUrl}?${query}`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}



export const addC2CVoucherApi = async (voucherData) => {
    try {
        
        const response = await API.post( 
            `restaurant${c2cVoucherUrl}`,
            voucherData
        );

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const editC2CVoucherApi = async (voucherData, id) => {
    try {
        
        const { data } = await API.put( 
            `restaurant${c2cVoucherUrl}/${id}`,
            {...voucherData}
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}


export const singleC2CVoucherApi = async (id) => {
    try {
        
        const { data } = await API.get( 
            `${c2cVoucherUrl}/${id}`,
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}



export const deleteC2CVoucherApi = async (id) => {
    try {
        
        const response = await API.delete(`restaurant${c2cVoucherUrl}/${id}`);

        return response.data;
    } catch (error) {
        return error.response.data;
    }
}

export const payC2CVoucherCashApi = async (id) => {
    try {
        const response = await API.post(`restaurant${c2cVoucherUrl}/${id}/pay-cash`);
        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const payC2CVoucherByLinkApi = async (id, payload = {}) => {
    try {
        const response = await API.post(`restaurant${c2cVoucherUrl}/${id}/pay-by-link`, payload);
        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const cancelC2CVoucherByLinkApi = async (id) => {
    try {
        const response = await API.post(`restaurant${c2cVoucherUrl}/${id}/pay-by-link/cancel`);
        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const payC2CVoucherCardApi = async (id) => {
    try {
        const response = await API.post(`restaurant${c2cVoucherUrl}/${id}/terminal-payment`);
        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const refundC2CVoucherApi = async (id) => {
    try {
        const response = await API.post(`restaurant${c2cVoucherUrl}/${id}/refund`);
        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const getC2CGiftCardClaimsApi = async (restaurant_id, query) => {
    try {
        const { data } = await API.get(
            `restaurant/${restaurant_id}${c2cVoucherUrl}/claims?${query}`
        );
        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const claimC2CGiftCardApi = async (code) => {
    try {
        const { data } = await API.post(
            `restaurant${c2cVoucherUrl}/claim/${code}`
        );
        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const sendC2CGiftCardEmailApi = async (id, payload, config = {}) => {
    try {
        const { data } = await API.post(
            `restaurant${c2cVoucherUrl}/${id}/send`,
            payload,
            config
        );
        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}